import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { createReadableClass } from '@elfsight/widget-utils';
import { Divider } from './divider';

export function DividedItem({ children }: PropsWithChildren) {
  return (
    <Container>
      <Divider />
      {children}
      <Divider />
    </Container>
  );
}

const Container = styled.div.attrs({
  className: createReadableClass({
    component: 'divided-item'
  })
})`
  display: flex;
  flex-direction: column;
  gap: 10px;

  width: 100%;
`;
